import { ScrollView, StyleSheet, View } from 'react-native';
import { Text } from 'react-native-paper';

import { UploadSettingsCard } from '@/components/organisms';
import { SettingsSubHeader } from '@/components/organisms/settings/SettingsSubHeader';
import { useTranslation } from '@/i18n';
import { fontSize, lineHeight, spacing, unisonColors } from '@/theme';

interface NetworkSettingsProps {
  readonly onBack: () => void;
}

export const NetworkSettings = ({ onBack }: NetworkSettingsProps) => {
  const { t } = useTranslation();

  return (
    <>
      <SettingsSubHeader title={t('settings.networkAndMobileData')} onBack={onBack} />
      <ScrollView style={styles.container} contentContainerStyle={styles.contentContainer}>
        <Text style={styles.description}>
          {t('settings.uploadSettings.allowMobileDataDescription')}
        </Text>
        <View style={styles.card}>
          <UploadSettingsCard />
        </View>
      </ScrollView>
    </>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: unisonColors.bgNlWeak,
  },
  contentContainer: {
    paddingTop: spacing[4],
    paddingHorizontal: spacing[4],
    gap: spacing[4],
  },
  description: {
    fontSize: fontSize.sm,
    lineHeight: lineHeight.md,
    color: unisonColors.textNdPrimary,
  },
  card: {
    backgroundColor: unisonColors.white,
    borderRadius: 8,
  },
});
